import { ServiceBot } from "./ServiceBot.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  ServiceBot
};
//# sourceMappingURL=index.js.map
